import Cookies from 'universal-cookie';
import { Preferences } from '@capacitor/preferences';
import { Capacitor } from '@capacitor/core';

const cookies = new Cookies();
const isNative = Capacitor.isNativePlatform();

const cookieDefaultOpts = {
  path: '/'
};

const storage = {
  async set(name, value, options = {}) {
    if (isNative) {
      await Preferences.set({ key: name, value });

      return;
    }

    cookies.set(name, value, {
      ...cookieDefaultOpts,
      ...options
    });
  },

  async get(name) {
    if (isNative) {
      const result = await Preferences.get({ key: name });

      return result.value;
    }

    return cookies.get(name);
  },

  // Used for web only (cookies)
  getSync(name) {
    if (isNative) {
      throw new Error('storage.getSync is not supported on native platforms, use the async get() instead');
    }

    return cookies.get(name);
  },

  async remove(name) {
    if (isNative) {
      await Preferences.remove({ key: name });
      return;
    }

    cookies.remove(name, { path: '/' });
  }
};

export default storage;
